<template>
    <div class="link-container">
        <a :href="href" :target="target" @click="callback">
            <label>{{ label }}</label>
            <img width="12" height="12" src="/wp-content/themes/bpa-health/dist/images/icons/arrow-circle-right.svg" />
        </a>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            required: true,
            type: String
        },
        href: {
            required: false,
            type: String
        },
        target: {
            default: 'self'
        },
        callback: {
            required: false,
            type: Function
        }
    },
    data () {
        return {

        }
    },
}
</script>
    
<style lang="scss" scoped>
.link-container {
    a {
        display: flex;
        gap: 16px;
        align-items: center;
        font-family: "Paralucent Demi";
        font-size: 12px;
        font-style: normal;
        line-height: 1.8;
        color: #0B3148;

        label {
            cursor: pointer;
            font-family: "Paralucent Demi";
        }

        &:hover {
            gap: 12px;
        }
    }

}
</style>